import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { FaMapMarkerAlt, FaCheckSquare, FaKeyboard } from 'react-icons/fa';
import { ClassroomContext } from '../../context/ClassroomContext';
import AuthContext from '../../context/AuthContext';
import styles from './styles/ClassroomSearchSidebar.module.css';
import SearchBar from '../common/SearchBar';

const ClassroomSearchSidebar = ({ classroomId, setSelectedStudent, setSelectedAssignment }) => {
    return (
        <div>
            {setSelectedStudent && <div>
                <h2>User Search</h2>
                <SearchBar type={'users'} classroomId={classroomId} setter={setSelectedStudent} />
            </div>}
            
            {setSelectedAssignment && <div>
                <h2>Assignment Search</h2>
                <SearchBar type={'assignments'} classroomId={classroomId} setter={setSelectedAssignment} />
            </div>}
        </div>
    );
};

export default ClassroomSearchSidebar;
